export const rootUrl = (path: string) => {
  return path.replace('/v2/', '/');
};
